import { Drawer as DsDrawer } from '@orbitalwatch/design';
import type { ReactNode } from 'react';

export interface DrawerProps {
    open: boolean;
    /** 18 px display title; names the dialog. */
    title: ReactNode;
    /** 11 px uppercase label above the title. */
    eyebrow?: ReactNode;
    /** First paragraph of the body (15 px text-2): what the drawer does. */
    lead?: ReactNode;
    onClose: () => void;
    /** Actions row: Cancel + one primary. */
    footer?: ReactNode;
    /** CSS width; default the library's `--ow-drawer-w` (36rem). */
    width?: string;
    children: ReactNode;
}

/**
 * Library `Drawer` (modal, focus trapped, Esc / scrim / Close, opens under the top bar inside the shell). The body
 * is a 16 px stack because every `FormField` already reserves its message line under the control.
 */
export function Drawer(props: DrawerProps) {
    return (
        <DsDrawer open={props.open} onClose={props.onClose} title={props.title} eyebrow={props.eyebrow} footer={props.footer} width={props.width}>
            <div className="ark-drawer-stack">
                {props.lead ? <p className="ark-lead">{props.lead}</p> : null}
                {props.children}
            </div>
        </DsDrawer>
    );
}
